// extracted by mini-css-extract-plugin
export var content = "_o4-1";
export var fullScreen = "_o4-0";